// import React, { useState } from "react";
// import styles from "../../assets/scss/Plans/UsersPlan.module.scss";
// import PopupWrapper from "../../Components/Common/PopupWrapper";
// import { useGetPlansQuery, useCreateRazorpayOrderMutation, useVerifyRazorpayPaymentMutation } from "../../slices/admin/admin";
// import { toast } from "react-toastify";

// const UsersPlan = ({ activePlanId, showChoosePlan }) => {
//   const [openPopup, setOpenPopup] = useState(false);
//   const [selectedPlan, setSelectedPlan] = useState(null);

//   const { data, isLoading } = useGetPlansQuery({ offset: 1, limit: 10 });
//   const [createOrder] = useCreateRazorpayOrderMutation();
//   const [verifyPayment] = useVerifyRazorpayPaymentMutation();

//   const plans = data?.data || [];

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleSelectPlan = async (plan) => {
//     if (plan.isFree) {
//       setSelectedPlan(plan);
//       setOpenPopup(true);
//       return;
//     }

//     try {
//       const res = await loadRazorpayScript();
//       if (!res) {
//         toast.error("Razorpay SDK failed to load");
//         return;
//       }

//       const orderResponse = await createOrder(plan._id).unwrap();

//       const options = {
//         key: orderResponse.key,
//         amount: orderResponse.amount,
//         currency: orderResponse.currency,
//         name: "Cropwork",
//         description: plan.planName,
//         order_id: orderResponse.orderId,
//         handler: async (response) => {
//           try {
//             await verifyPayment({
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             }).unwrap();
//             toast.success("Payment successful!");
//           } catch (error) {
//             toast.error("Payment verification failed");
//           }
//         },
//         theme: { color: "#3399cc" },
//       };

//       const paymentObject = new window.Razorpay(options);
//       paymentObject.open();
//     } catch (error) {
//       toast.error(error?.data?.message || "Failed to create order");
//     }
//   };

//   const handleClose = () => {
//     setOpenPopup(false);
//     setSelectedPlan(null);
//   };

//   return (
//     <>
//       <div className={styles.plansWrapper}>
//         <div className={styles.cardsContainer}>
//           {isLoading && <p>Loading plans...</p>}

//           {!isLoading && plans.length === 0 && (
//             <p>No plans available</p>
//           )}

//           {plans.map((plan) => {
//             const isActivePlan = plan._id === activePlanId;
//             return (
//               <div
//                 key={plan._id}
//                 className={`${styles.card} ${isActivePlan ? styles.activeCard : ""}`}
//               >
//                 {isActivePlan && <span className={styles.activeBadge}>Active</span>}
//                 <h2>{plan.planName}</h2>

//                 <h3 className={styles.price}>
//                   {plan.isFree
//                     ? "Free Plan"
//                     : `₹${plan.price} / ${plan.duration} ${plan.durationType}`}
//                 </h3>

//                 <p>{plan.description}</p>
                
//                 {showChoosePlan && (
//                   <div className={styles.addBtnUser}>
//                     <button
//                       className={styles.addBtn}
//                       onClick={() => handleSelectPlan(plan)}
//                     >
//                       Choose plan
//                     </button>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {openPopup && (
//         <PopupWrapper
//           title={selectedPlan?.planName}
//           onClose={handleClose}
//         >
//           <h2>
//             You selected: {selectedPlan?.planName}
//           </h2>
//           <p>
//             {selectedPlan?.isFree
//               ? "This is a free plan."
//               : `Price: ₹${selectedPlan?.price}`}
//           </p>
//         </PopupWrapper>
//       )}
//     </>
//   );
// };

// export default UsersPlan;



import React, { useState } from "react";
import styles from "../../assets/scss/Plans/UsersPlan.module.scss";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import {
  useGetPlansQuery,
  useCreateRazorpayOrderMutation,
  useVerifyRazorpayPaymentMutation
} from "../../slices/admin/admin";
import { toast } from "react-toastify";

const UsersPlan = ({ activePlanId, showChoosePlan }) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const { data, isLoading } = useGetPlansQuery({ offset: 1, limit: 10 });

  const [createOrder] = useCreateRazorpayOrderMutation();
  const [verifyPayment] = useVerifyRazorpayPaymentMutation();

  const plans = data?.data || [];

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleSelectPlan = async (plan) => {

    if (plan.isFree) {
      setSelectedPlan(plan);
      setOpenPopup(true);
      return;
    }

    try {

      const scriptLoaded = await loadRazorpayScript();

      if (!scriptLoaded) {
        toast.error("Razorpay SDK failed to load");
        return;
      }

      const orderResponse = await createOrder(plan._id).unwrap();

      const options = {
        key: orderResponse.key,
        amount: orderResponse.amount,
        currency: orderResponse.currency,
        name: "Cropwork",
        description: plan.planName,
        order_id: orderResponse.orderId,

        handler: async function (response) {
          try {

            await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            }).unwrap();

            toast.success("Payment Successful");
            window.location.reload();

          } catch (err) {

            toast.error("Payment verification failed");

          }
        },

        modal: {
          ondismiss: () => {

            toast.info("Payment Cancelled");
            window.location.reload();

          }
        },

        theme: {
          color: "#3399cc"
        }
      };

      const paymentObject = new window.Razorpay(options);

      // ✅ PAYMENT FAILURE HANDLE
      paymentObject.on("payment.failed", async function (response) {

        try {

          await verifyPayment({
            razorpay_order_id: response.error.metadata.order_id,
            razorpay_payment_id: response.error.metadata.payment_id,
            razorpay_signature: null,
            status: "failed",
            reason: response.error.description
          }).unwrap();

          toast.error("Payment Failed");

          window.location.reload();

        } catch (error) {

          toast.error("Failed to update failure status");

        }

      });

      paymentObject.open();

    } catch (error) {

      toast.error(error?.data?.message || "Failed to create order");

    }
  };

  const handleClose = () => {
    setOpenPopup(false);
    setSelectedPlan(null);
  };

  return (
    <>
      <div className={styles.plansWrapper}>
        <div className={styles.cardsContainer}>

          {isLoading && <p>Loading plans...</p>}

          {!isLoading && plans.length === 0 && (
            <p>No plans available</p>
          )}

          {plans.map((plan) => {

            const isActivePlan = plan._id === activePlanId;

            return (
              <div
                key={plan._id}
                className={`${styles.card} ${isActivePlan ? styles.activeCard : ""}`}
              >

                {isActivePlan && (
                  <span className={styles.activeBadge}>Active</span>
                )}

                <h2>{plan.planName}</h2>

                <h3 className={styles.price}>
                  {plan.isFree
                    ? "Free Plan"
                    : `₹${plan.price} / ${plan.duration} ${plan.durationType}`}
                </h3>

                <p>{plan.description}</p>

                {showChoosePlan && (
                  <div className={styles.addBtnUser}>
                    <button
                      className={styles.addBtn}
                      onClick={() => handleSelectPlan(plan)}
                    >
                      Choose plan
                    </button>
                  </div>
                )}

              </div>
            );
          })}
        </div>
      </div>

      {openPopup && (
        <PopupWrapper
          title={selectedPlan?.planName}
          onClose={handleClose}
        >
          <h2>You selected: {selectedPlan?.planName}</h2>

          <p>
            {selectedPlan?.isFree
              ? "This is a free plan."
              : `Price: ₹${selectedPlan?.price}`}
          </p>

        </PopupWrapper>
      )}
    </>
  );
};

export default UsersPlan;
